import { render, staticRenderFns } from "./CrmProfile.vue?vue&type=template&id=2ddb9ea5&scoped=true"
import script from "./CrmProfile.vue?vue&type=script&lang=js"
export * from "./CrmProfile.vue?vue&type=script&lang=js"
import style0 from "./CrmProfile.vue?vue&type=style&index=0&id=2ddb9ea5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ddb9ea5",
  null
  
)

export default component.exports